const OPEN_TAG = "<research>";

export function stripResearchTag(text: string): string {
  let out = text.replace(/<research>[\s\S]*?<\/research>\s*/, "");
  const open = out.indexOf(OPEN_TAG);
  if (open !== -1) return out.slice(0, open).trim();
  for (let i = OPEN_TAG.length - 1; i > 0; i--) {
    if (out.endsWith(OPEN_TAG.slice(0, i))) {
      out = out.slice(0, -i);
      break;
    }
  }
  return out.trim();
}
